module.exports = __webpack_public_path__ + "img/arrow-navigation.06bf1399.svg";